import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { InfoTrack } from '@/components/atoms/InfoTrack';
import { Picture } from '@deyvis17gy/atom-img';
import {
  addFavorite,
  removeFavorite,
  selectFavorite
} from '@/features/favorite/favoriteSlice';
import {
  playlistByIdBeezer,
  setFavorite
} from '@/features/playlist/playlistSlice';
import { ITrackCardProps, ITracksId } from '@/interface';
import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './trackItem.scss';
import { setIsWriting } from '@/features/search/searchSlice';
import {
  setAutoPlay,
  setTrackById,
  setTrackSingleId
} from '@/features/singleTrack/singleTrackSlice';
import { FavoriteIcon } from '@/components/atoms/FavoriteIcon';
import { useParams } from 'react-router-dom';
import loader from '@/assets/img/Spinning.gif';
import { saveFavorites, updateFavorites } from '@/services/firebaseApi';
import { useAuthStore } from '@/zustand/useAuthGoogle';

export const TrackItem = ({ tracks, isGuest }: ITrackCardProps) => {
  const dispatch = useAppDispatch();
  const { favoriteTracks } = useAppSelector(selectFavorite);
  const params = useParams();
  const [listTracks, setListTracks] = useState<ITracksId[]>([]);
  const [isSelectedTrackId, setIsSelectedTrackId] = useState<string>('');
  const { user: userGoogle } = useAuthStore((state) => state);

  const selectFavorites = async (id: string) => {
    listTracks
      ?.filter((track) => track.track.id === id)
      .map(async (track) => {
        if (
          track.track.isFavorite === undefined ||
          track.track.isFavorite === false
        ) {
          const newFavorite = {
            ...track,
            track: {
              ...track.track,
              isFavorite: true
            }
          };
          dispatch(addFavorite(newFavorite));
          dispatch(setFavorite(track, true));
          await saveFavorites(userGoogle?.uid, [
            ...favoriteTracks.items.filter((t) => t.id !== track.id),
            newFavorite
          ]);
        } else {
          dispatch(setFavorite(track, false));
          console.debug('favoriteTracks.items.filter', favoriteTracks.items);
          dispatch(removeFavorite(track));

          await updateFavorites(
            userGoogle?.uid,
            favoriteTracks.items.filter((f) => f.id !== track.id),
            userGoogle?.uid
          );
        }
        return track;
      });
  };

  const selectedTrack = (track: ITracksId) => {
    //clickAudio?.(track)
    dispatch(setTrackSingleId({} as ITracksId));
    setIsSelectedTrackId(track.track.id);
    dispatch(setTrackById(track));
    dispatch(setIsWriting(false));
    dispatch(setAutoPlay(true));
  };
  useEffect(() => {
    if (!tracks?.items && isGuest) {
      if (!params.id) return;
      dispatch(playlistByIdBeezer(params.id));
      return;
    }
    if (!tracks.items) return;
    const validateTracks = tracks.items.map((track) => {
      if (!track.id) return;
      if (
        favoriteTracks.items.filter(
          (favorite) => favorite?.track?.id === track.track.id
        ).length > 0
      ) {
        return {
          ...track,
          track: {
            ...track.track,
            isFavorite: true
          }
        };
      } else {
        return {
          ...track,
          track: {
            ...track.track,
            isFavorite: false
          }
        };
      }
    });

    const validateTracksPreview = validateTracks
      .filter((track) => {
        if (track === undefined) return;
        return (
          track.track.preview_url !== undefined &&
          track.track.preview_url !== null &&
          track.track.preview_url !== ''
        );
      })
      .reverse() as ITracksId[];

    setListTracks(validateTracksPreview);
  }, [tracks, favoriteTracks, dispatch, params.id, isGuest]);
  return (
    <>
      {listTracks.length > 0 &&
        listTracks.map((tr, index) => (
          <motion.div
            animate={{
              opacity: 1,
              transition: { duration: 0.5, ease: 'easeInOut' }
            }}
            initial={{ opacity: 0 }}
            key={index}
            transition={{ duration: 0.2, ease: 'easeInOut' }}>
            <div className='m-track' key={tr.track.id}>
              <motion.section
                onClick={() => selectedTrack(tr)}
                className='m-track__tracks'
                animate={{
                  opacity: 1,
                  transition: { duration: 0.5, ease: 'easeInOut' }
                }}
                initial={{ opacity: 0 }}
                transition={{ duration: 0.2, ease: 'easeInOut' }}
                whileTap={{ scale: 0.999 }}>
                <Picture
                  loaderUrl={loader}
                  url={tr.track.album.images[0].url}
                  classPicture='m-track__image'
                  alt={tr.track.name}
                />
                <InfoTrack
                  isSelected={tr.track.id === isSelectedTrackId}
                  album={tr.track.name}
                  artist={tr.track.artists[0].name}
                />
              </motion.section>
              <FavoriteIcon
                isFavorite={tr.track.isFavorite}
                onClick={() => selectFavorites(tr.track.id)}
              />
            </div>
          </motion.div>
        ))}
    </>
  );
};
